const PAGE_SIZE = "pageSize";

export const setPageSize = (count: number) =>
  localStorage.setItem(PAGE_SIZE, count.toString());

export const getPageSize = () => localStorage.getItem(PAGE_SIZE);
